import { Button, Grid, Group, NumberInput, Select, Text } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { models } from '../../constants/models';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import AdjustableTextArea from '../GeneratedContent/AdjustableTextArea';
import Spinner from '../Spinner';

const SuperAdminChatBotSettingsLocale = ({ locale }) => {
  const [settings, setSettings] = useState();
  const [initialSettings, setInitialSettings] = useState();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const customFetch = useFetch();

  const handleChange = (event) => {
    setSettings({ ...settings, [event.target.name]: event.target.value });
  };

  const settingsChanged = !loading && JSON.stringify(settings) !== JSON.stringify(initialSettings);

  const fetchUrl = `/api/admin/chatBotSettings/${locale}`;

  useEffect(() => {
    setSettings(undefined);
    customFetch(fetchUrl)
      .then(({ settings }) => {
        setSettings(settings);
        setInitialSettings(settings);
      })
      .catch(setError);
  }, [fetchUrl, customFetch]);

  const updateSettings = () => {
    setLoading(true);
    customFetch(`/api/admin/chatBotSettings/${locale}`, {
      method: 'PUT',
      body: JSON.stringify({ settings }),
    })
      .then(({ settings }) => {
        setSettings(settings);
        setInitialSettings(settings);
      })
      .catch(setError)
      .finally(() => setLoading(false));
  };

  if (!settings) {
    return <Spinner />;
  }

  return (
    <>
      <Grid align="center" mb="sm">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text fw={500}>Model</Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }} pt="sm">
          <Select
            value={settings.model}
            data={models.rlv}
            onChange={(value) => handleChange({ target: { name: 'model', value } })}
            placeholder="Select chat bot model"
          />
          <Text size="sm" c="dimmed">
            Select which model to use Releva AI chat bot.
          </Text>
        </Grid.Col>
      </Grid>
      <Grid align="center" mb="sm">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text fw={500}>Number of Documents</Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <NumberInput
            name="documents"
            value={settings.documents || ''}
            min={0}
            max={50}
            placeholder="0"
            onChange={(value) => handleChange({ target: { name: 'documents', value } })}
          />
          <Text size="sm" c="dimmed">
            Select number of documents that will be searched with every prompt of the Releva AI chat bot.
          </Text>
        </Grid.Col>
      </Grid>
      <Grid align="center" mb="sm">
        <Grid.Col span={{ base: 12, sm: 2 }}>
          <Text fw={500}>System prompt</Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 10 }}>
          <AdjustableTextArea id="prompt" name="prompt" value={settings.prompt || ''} onChange={handleChange} />
          <Text size="sm" c="dimmed">
            Customize system prompt for Chat bot for better results.
          </Text>
        </Grid.Col>
      </Grid>

      <Group justify="flex-end" gap="xs" py="md">
        <ErrorMessage message={error?.message} />
        <Button onClick={() => updateSettings(settings)} disabled={loading || !settingsChanged}>
          <IconDeviceFloppy size={16} /> Save
        </Button>
      </Group>
    </>
  );
};

export default SuperAdminChatBotSettingsLocale;
